import { render, staticRenderFns } from "./ShortlistItem.vue?vue&type=template&id=6e6052d2&scoped=true&"
import script from "./ShortlistItem.vue?vue&type=script&lang=js&"
export * from "./ShortlistItem.vue?vue&type=script&lang=js&"
import style0 from "./ShortlistItem.vue?vue&type=style&index=0&id=6e6052d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6052d2",
  null
  
)

export default component.exports